// Kademeli acilis listesi: Site Ayarlari ve Panel ekranlari yalnizca asagidaki
// hesaplara gorunur. Dashboard'daki iki giris butonu da, sayfalarin kendisi de
// bu tek listeyi kullanir — izin tek yerden yonetilsin diye ayri liste tutulmuyor.
export const WEB_SETTINGS_ALLOWED_EMAILS = [
    'cemile@extranetwork.com',
    'bulut@extranetwork.com',
    'yoy@extranetwork.com',
    'onur@extranetwork.com',
    'cem@extranetwork.com',
    'partnerships@extranetwork.com'
];

export function isWebSettingsAllowed(email) {
    if (!email) return false;
    return WEB_SETTINGS_ALLOWED_EMAILS.includes(String(email).toLowerCase());
}

export default WEB_SETTINGS_ALLOWED_EMAILS;
